export const defaultToolbar = {
  options: ["history", "fontFamily", "fontSize", "inline", "list", "link"],
  inline: {
    options: ["bold", "italic", "underline", "strikethrough"],
  },
};
